import { createSelector } from "reselect";
import get from "lodash/get";

const approvalQueueState = (state) =>
  get(state, "approvals.approvalQueue", null);

export const getApprovalQueue = createSelector(approvalQueueState, (state) =>
  get(state, "queue", [])
);
